import { render, staticRenderFns } from "./ErrorLink.vue?vue&type=template&id=2e41e36c&scoped=true"
import script from "./ErrorLink.vue?vue&type=script&lang=js"
export * from "./ErrorLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41e36c",
  null
  
)

export default component.exports